<template>

    <div
        :class="{'form-group':true, 'has-error':error !== ''}"
        style="margin-bottom:20px;"
    >
        <label
            v-if="label"
            class="control-label"
            :for="id"
            style="margin-bottom:0 !important;"
        >{{ label }}:</label>
        <div
            class="radio"
            style="margin-top:5px !important;"
        >
            <label :for="id">
                <input
                    :title="trans.yes"
                    type="radio"
                    :name="id"
                    :id="id"
                    :checked="value === true"
                    @input="$emit('input', $event.target.value === 'true')"
                    :value="true"
                    tabindex="1"
                />
                {{ trans.yes }}
            </label>
        </div>
        <div class="radio">
            <label :for="idfalse">
                <input
                    :title="trans.no"
                    type="radio"
                    :name="id"
                    :checked="value === false"
                    :id="idfalse"
                    @input="$emit('input', $event.target.value === 'true')"
                    :value="false"
                    tabindex="1"
                />
                {{ trans.no }}
            </label>
        </div>
        <small v-if="error === '' && description !== null" class="help-block" v-html="description"></small>
        <span v-if="error !== ''" class="help-block">{{ error }}</span>
    </div>

</template>

<script>

export default {

    inheritAttrs:false,

    name: 'CFormYesNoRadio',

    props:{
        description:{
            type:String,
            default:null,
        },
        error:{
            type:String,
            default:'',
        },
        id:{
            type:String,
            default(){
                return `yes-no-radio-${this._uid}`
            },
        },
        idfalse:{
            type:String,
            default(){
                return `yes-no-radio-${this._uid}-false`
            },
        },
        label:String,
        placeholder:{
            type:String,
            default:"",
        },
        type:{
            type:String,
            default:'text',
        },
        trans:{
            type:Object,
            default() {
                return {
                    yes:'Ja',
                    no:'Nee',
                };
            },
        },
        value:{
            default:false,
        },
    },
}

</script>
